<template>
  <div class="container">
    <div class="conditions_box">
      <img src="@/assets/archedShape2.png" class="img-fluid gonbad"/>

      <div class="row">

        <div class="col-12 col-md-8 mx-auto">
          <div class="content-wrapper">
            <h1>ثبت نام اولیه سامانه پلیس امنیت</h1>
            <div class="card content-box">
              <div class="card-body">
                <p class="text-justify intro-text">
                  <span>در صورت علاقه مندی جهت ثبت نام در سامانه برخط ناظر یک</span><br>
                  <span>لطفا فرم زیر را کامل فرمایید.</span><br>
                  <span>نکات قبل از ثبت نام اولیه:</span><br>
                  <span>1. تکمیل این فرم و انجام مراحل بعدی به منزله تایید نهایی نمی باشد و بایستی پس از تکمیل مراحل، پلیس امنیت عمومی نیروی انتظامی ثبت نام را تایید نماید.</span><br>
                  <span>2- جهت تکمیل فرآیند ثبت نام، پس از پر کردن این فرم، مراحل بعد را تکمیل بفرمایید.</span><br>
                </p>
                <form action="" class="text-end">
                  <div class="row mb-3">
                    <div class="col">
                      <label for="registerFirstName" class="form-label">نام</label>
                      <input type="text" class="form-control" id="registerFirstName">
                    </div>
                    <div class="col">
                      <label for="registerLastName" class="form-label">نام خانوادگی</label>
                      <input type="text" class="form-control" id="registerLastName">
                    </div>
                  </div>
                  <div class="row mb-3">
                    <div class="col">
                      <label for="registerSex" class="form-label">جنسیت</label>
                      <select class="form-select" id="registerSex">
                        <option></option>
                        <option value="male">آقا</option>
                        <option value="female">خانم</option>
                      </select>
                    </div>
                  </div>
                  <div class="row mb-3">
                    <div class="col">
                      <label for="registerProvince" class="form-label">استان</label>
                      <select class="form-select" id="registerProvince">
                        <option></option>
                        <option value="1">One</option>
                        <option value="2">Two</option>
                        <option value="3">Three</option>
                      </select>
                    </div>
                    <div class="col">
                      <label for="registerCity" class="form-label">شهر</label>
                      <select class="form-select" id="registerCity">
                        <option></option>
                        <option value="1">One</option>
                        <option value="2">Two</option>
                        <option value="3">Three</option>
                      </select>
                    </div>
                  </div>
                </form>
                <RouterLink to="/introFourth" class="bbot mx-auto">
                  ▶ صفحه قبل
                </RouterLink>
                <RouterLink to="/rule-tutorial" class="bbot mx-auto">
                  صفحه بعد ◀
                </RouterLink>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style>
.control-label {
  font-size: 13px;
  margin-top: 10px;
}
</style>
<script>
/*import HelloWorld from '@/components/HelloWorld.vue'

export default {
  name: 'HomeView',
  components: {
    HelloWorld
  }
}*/

</script>
